import { createContext, useContext, type ReactNode } from 'react';

type TooltipBoundsContextType = {
  /** Left edge X coordinate of the tooltip container (viewport-relative) */
  containerLeftX?: number;
};

const TooltipBoundsContext = createContext<TooltipBoundsContextType>({});

export function TooltipBoundsProvider({
  containerLeftX,
  children,
}: {
  containerLeftX?: number;
  children: ReactNode;
}) {
  return (
    <TooltipBoundsContext.Provider value={{ containerLeftX }}>
      {children}
    </TooltipBoundsContext.Provider>
  );
}

export function useTooltipBounds(): TooltipBoundsContextType {
  return useContext(TooltipBoundsContext);
}
